module.exports = __webpack_public_path__ + "img/max16.288b3334.png";